import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { BrandM } from '@sorare/core/src/atoms/typography';

import type { Section } from 'hooks/zendesk';
import { useArticles } from 'hooks/zendesk';
import { articlePath, sectionPath } from 'lib/path';

const Wrapper = styled.div`
  & ul {
    padding-left: var(--triple-unit);

    & li {
      list-style: disc;
      font-size: var(--t-20);
      line-height: 140%;
    }
  }
`;

export const Articles = ({ section }: { section: Section }) => {
  const articles = useArticles(section.id);

  return (
    <Wrapper>
      <BrandM as="h2">
        <Link to={sectionPath(section)}>{section.name}</Link>
      </BrandM>

      <ul>
        {articles.map(article => (
          <li key={article.id}>
            <Link to={articlePath(article)}>{article.title}</Link>
          </li>
        ))}
      </ul>
    </Wrapper>
  );
};
